import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHealthBillingInfoSlice = createSlice({
  name: "getHealthBillingInfo",
  initialState,
  reducers: {
    getHealthBillingInfoStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHealthBillingInfoSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHealthBillingInfoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHealthBillingInfoStart,
  getHealthBillingInfoSuccess,
  getHealthBillingInfoFailure,
  clearError,
  clearMessage,
} = getHealthBillingInfoSlice.actions;

export default getHealthBillingInfoSlice.reducer;
